module.exports = __webpack_public_path__ + "img/chengjiaci.06618d8d.jpg";